import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchForm from '../components/SearchForm';
import { getDestinationImages, getCityName } from '../data/routes';
import { useBooking } from '../context/BookingContext';
import { useLanguage } from '../context/LanguageContext';
import { Wifi, AirVent, Smartphone, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react';

const reviews = [
  { name: { ru: 'Аисте', en: 'Aiste', lv: 'Aiste', lt: 'Aistė', pl: 'Aiste' },
    text: { ru: 'Я выбрала Lux Express для поездки в Таллинн и была приятно удивлена. Автобусы были чистыми, водители были добрыми, время в пути пролетело незаметно за просмотром фильмов!', en: 'I chose Lux Express for my trip to Tallinn and was pleasantly surprised. The buses were clean, the drivers were kind, and the time flew by watching movies!', lv: 'Es izvēlējos Lux Express ceļojumam uz Tallinu un biju patīkami pārsteigta. Autobusi bija tīri, šoferi laipni, laiks lidojumā pagāja nemanot, skatoties filmas!', lt: 'Pasirinkau Lux Express kelionei į Taliną ir buvau maloniai nustebinta. Autobusai buvo švarūs, vairuotojai malonūs, kelionės laikas prabėgo nepastebėtai žiūrint filmus!', pl: 'Wybrałam Lux Express na podróż do Tallinna i byłam mile zaskoczona. Autobusy były czyste, kierowcy mili, czas w podróży minął niepostrzeżenie przy oglądaniu filmów!' } },
  { name: { ru: 'Тоомас', en: 'Toomas', lv: 'Toomass', lt: 'Toomas', pl: 'Toomas' },
    text: { ru: 'Сегодня водитель автобуса, отправлявшегося из Тарту, был очень приятен и выступил с хорошей новогодней речью. Это оставило у меня теплое чувство, он также поблагодарил всех пассажиров за выбор Lux Express.', en: 'Today the bus driver departing from Tartu was very pleasant and gave a nice New Year speech. It left me with a warm feeling, he also thanked all passengers for choosing Lux Express.', lv: 'Šodien autobusa šoferis, kas izbrauca no Tartu, bija ļoti patīkams un teica jauku Jaungada uzrunu. Tas atstāja siltu sajūtu, viņš arī pateicās visiem pasažieriem par Lux Express izvēli.', lt: 'Šiandien autobuso vairuotojas, išvykęs iš Tartu, buvo labai malonus ir pasakė gražią Naujųjų metų kalbą. Tai paliko šiltą jausmą, jis taip pat padėkojo visiems keleiviams už Lux Express pasirinkimą.', pl: 'Dzisiaj kierowca autobusu wyjeżdżającego z Tartu był bardzo miły i wygłosił fajną noworoczną mowę. Zostawiło to ciepłe uczucie, podziękował też wszystkim pasażerom za wybór Lux Express.' } },
  { name: { ru: 'Марис', en: 'Māris', lv: 'Māris', lt: 'Māris', pl: 'Māris' },
    text: { ru: 'Регулярно езжу по маршруту Рига — Вильнюс. Всегда вовремя, комфортные кресла, бесплатный Wi-Fi и горячий кофе. Лучший способ путешествовать между столицами Балтии!', en: 'I regularly travel the Riga — Vilnius route. Always on time, comfortable seats, free Wi-Fi and hot coffee. The best way to travel between Baltic capitals!', lv: 'Regulāri braucu maršrutā Rīga — Viļņa. Vienmēr laikā, ērti krēsli, bezmaksas Wi-Fi un karsta kafija. Labākais veids ceļot starp Baltijas galvaspilsētām!', lt: 'Reguliariai keliauju maršrutu Ryga — Vilnius. Visada laiku, patogios krėslai, nemokamas Wi-Fi ir karšta kava. Geriausias būdas keliauti tarp Baltijos sostinių!', pl: 'Regularnie podróżuję trasą Ryga — Wilno. Zawsze na czas, wygodne fotele, darmowe Wi-Fi i gorąca kawa. Najlepszy sposób podróżowania między stolicami Bałtyku!' } },
  { name: { ru: 'Катажина', en: 'Katarzyna', lv: 'Katažina', lt: 'Katažina', pl: 'Katarzyna' },
    text: { ru: 'Путешествовала из Варшавы в Ригу ночным рейсом. Кресла удобные, можно разложить и поспать. Приехали точно по расписанию. Рекомендую для длинных маршрутов!', en: 'Traveled from Warsaw to Riga on a night bus. The seats are comfortable, you can recline and sleep. We arrived exactly on schedule. Recommended for long routes!', lv: 'Ceļoju no Varšavas uz Rīgu ar nakts reisu. Krēsli ērti, var atlaisties un pagulēt. Ieradāmies precīzi pēc grafika. Iesaku gariem maršrutiem!', lt: 'Keliavau iš Varšuvos į Rygą naktiniu reisu. Sėdynės patogios, galima atlošti ir pamiegoti. Atvykome tiksliai pagal tvarkaraštį. Rekomenduoju ilgiems maršrutams!', pl: 'Podróżowałam z Warszawy do Rygi nocnym kursem. Fotele wygodne, można rozłożyć i pospać. Dojechaliśmy dokładnie według rozkładu. Polecam na długie trasy!' } },
  { name: { ru: 'Йонас', en: 'Jonas', lv: 'Jonass', lt: 'Jonas', pl: 'Jonas' },
    text: { ru: 'Впервые ехал на двухэтажном автобусе Superior из Таллинна в Тарту. Панорамная крыша просто невероятная! Кофемашина с бесплатным кофе и шоколадом — отличный бонус.', en: 'First time riding the double-decker Superior bus from Tallinn to Tartu. The panoramic roof is simply incredible! The coffee machine with free coffee and chocolate is a great bonus.', lv: 'Pirmo reizi braucu ar divstāvu autobusu Superior no Tallinas uz Tartu. Panorāmas jumts ir vienkārši neticams! Kafijas automāts ar bezmaksas kafiju un šokolādi — lielisks bonuss.', lt: 'Pirmą kartą važiavau dviejų aukštų autobusu Superior iš Talino į Tartu. Panoraminis stogas tiesiog neįtikėtinas! Kavos aparatas su nemokama kava ir šokoladu — puikus bonusas.', pl: 'Po raz pierwszy jechałem piętrowym autobusem Superior z Tallinna do Tartu. Panoramiczny dach jest po prostu niesamowity! Ekspres do kawy z darmową kawą i czekoladą — świetny bonus.' } },
  { name: { ru: 'Элина', en: 'Elīna', lv: 'Elīna', lt: 'Elīna', pl: 'Elīna' },
    text: { ru: 'Часто путешествую с детьми на маршруте Рига — Даугавпилс. Дети в восторге от персональных экранов! Ремни безопасности на каждом сиденье — спокойно за безопасность.', en: 'I often travel with children on the Riga — Daugavpils route. The kids love the personal screens! Seat belts on every seat — peace of mind for safety.', lv: 'Bieži ceļoju ar bērniem maršrutā Rīga — Daugavpils. Bērni ir sajūsmā par personālajiem ekrāniem! Drošības jostas katrā sēdeklī — mierīga sajūta par drošību.', lt: 'Dažnai keliauju su vaikais maršrutu Ryga — Daugpilis. Vaikai dievina asmeninius ekranus! Saugos diržai kiekvienoje sėdynėje — ramybė dėl saugumo.', pl: 'Często podróżuję z dziećmi na trasie Ryga — Dyneburg. Dzieci uwielbiają osobiste ekrany! Pasy bezpieczeństwa na każdym siedzeniu — spokój o bezpieczeństwo.' } },
];

const ReviewsSection = ({ t }) => {
  const { lang } = useLanguage();
  const [page, setPage] = useState(0);
  const perPage = typeof window !== 'undefined' && window.innerWidth < 768 ? 1 : 2;
  const totalPages = Math.ceil(reviews.length / perPage);

  return (
    <section className="py-8 md:py-16 bg-white overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[40px] font-semibold text-[#c30909] mb-6 md:mb-10">
          {t('reviews.title')}
        </h2>
        <div className="overflow-hidden mb-6">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${page * 100}%)` }}
          >
            {Array.from({ length: totalPages }).map((_, pageIdx) => {
              const pageReviews = reviews.slice(pageIdx * perPage, pageIdx * perPage + perPage);
              return (
                <div key={pageIdx} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {pageReviews.map((review, idx) => (
                      <div key={idx} className="relative">
                        <div className="text-[#c30909] text-5xl font-serif leading-none mb-3">&ldquo;</div>
                        <p className="text-[16px] md:text-[20px] text-[#333] leading-[1.7] mb-4 italic">
                          {review.text[lang] || review.text.en}
                        </p>
                        <p className="text-[15px] font-bold text-[#333]">{review.name[lang] || review.name.en}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage(Math.max(0, page - 1))}
            disabled={page === 0}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <ChevronLeft size={16} strokeWidth={2.5} />
            <span className="font-medium">{t('reviews.prev')}</span>
          </button>
          <div className="flex-1 h-px bg-gray-200" />
          <button
            onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
            disabled={page >= totalPages - 1}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${page >= totalPages - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <span className="font-bold">{t('reviews.next')}</span>
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </section>
  );
};

const destinationDescriptions = {
  ru: {
    'Таллинн': 'Средневековый Старый город, включённый в список ЮНЕСКО. Сочетание истории и современности делает Таллинн одним из самых интересных городов Балтии.',
    'Хельсинки': 'Столица Финляндии с уникальной архитектурой, дизайном и морскими пейзажами. Город, где встречаются Север и Восток.',
    'Нарва': 'Город на границе двух культур с впечатляющей крепостью XIII века. Богатое культурное наследие в сочетании с современными инновациями.',
    'Рига': 'Жемчужина Балтии с крупнейшей коллекцией зданий в стиле ар-нуво в Европе. Старый город — объект ЮНЕСКО.',
    'Тарту': 'Город студентов и науки с живой молодёжной атмосферой. Здесь расположен один из старейших университетов Северной Европы.',
    'Вильнюс': 'Крупнейший Старый город в Восточной Европе, объект ЮНЕСКО. Наследие многих культур и уютные кафе на каждом углу.',
    'Варшава': 'Город контрастов: восстановленный Старый город, современные небоскрёбы и богатая культурная жизнь столицы Польши.',
    'Пярну': 'Летняя столица Эстонии с прекрасными песчаными пляжами и многочисленными спа-курортами. Идеально для отдыха.',
    'Курессааре': 'Волшебный остров Сааремаа со средневековым епископским замком. Место, где время течёт по-особенному.',
    'Даугавпилс': 'Второй по величине город Латвии с уникальной крепостью XIX века и Арт-центром Марка Ротко.',
    'Лиепая': 'Город, где рождается ветер. Прекрасные пляжи, уникальный Каростский квартал и богатые музыкальные традиции.',
    'Хаапсалу': 'Живописный приморский курортный город с епископским замком. Идиллическое место для множества культурных мероприятий.',
    'Хийумаа': 'Остров Хийумаа славится своими маяками, девственной природой, чувством юмора местных жителей и неповторимой островной атмосферой.',
  },
  en: {
    'Tallinn': 'Medieval Old Town, a UNESCO World Heritage Site. The blend of history and modernity makes Tallinn one of the most fascinating Baltic cities.',
    'Helsinki': 'Finland\'s capital with unique architecture, design and seascapes. Where North meets East.',
    'Narva': 'A city on the border of two cultures with an impressive 13th-century fortress. Rich cultural heritage meets modern innovation.',
    'Riga': 'The pearl of the Baltics with Europe\'s largest collection of Art Nouveau buildings. Old Town is a UNESCO site.',
    'Tartu': 'A city of students and science with a lively youthful atmosphere. Home to one of Northern Europe\'s oldest universities.',
    'Vilnius': 'The largest Old Town in Eastern Europe, a UNESCO site. Heritage of many cultures and cozy cafes on every corner.',
    'Warsaw': 'A city of contrasts: restored Old Town, modern skyscrapers and the rich cultural life of Poland\'s capital.',
    'Pärnu': 'Estonia\'s summer capital with beautiful sandy beaches and numerous spa resorts. Perfect for relaxation.',
    'Kuressaare': 'The magical island of Saaremaa with a medieval episcopal castle. A place where time flows differently.',
    'Daugavpils': 'Latvia\'s second largest city with a unique 19th-century fortress and the Mark Rothko Art Centre.',
    'Liepāja': 'The city where the wind is born. Beautiful beaches, unique Karosta quarter and rich musical traditions.',
    'Haapsalu': 'A picturesque seaside resort town with a bishop\'s castle. An idyllic place for many cultural events.',
    'Hiiumaa': 'Hiiumaa island is famous for its lighthouses, pristine nature, sense of humor of its locals and unique island atmosphere.',
  },
  lv: {
    'Tallina': 'Viduslaiku Vecpilsēta, UNESCO mantojuma sarakstā. Vēstures un modernitātes apvienojums.',
    'Helsinki': 'Somijas galvaspilsēta ar unikālu arhitektūru, dizainu un jūras ainavām.',
    'Narva': 'Pilsēta divu kultūru robežā ar iespaidīgu 13. gadsimta cietoksni.',
    'Rīga': 'Baltijas pērle ar lielāko jūgendstila ēku kolekciju Eiropā.',
    'Tartu': 'Studentu un zinātnes pilsēta ar dzīvu jaunības atmosfēru.',
    'Viļņa': 'Lielākā Vecpilsēta Austrumeiropā, UNESCO mantojums.',
    'Varšava': 'Kontrastu pilsēta: atjaunotā Vecpilsēta un moderni debesskrāpji.',
    'Pērnava': 'Igaunijas vasaras galvaspilsēta ar brīnišķīgām pludmalēm.',
    'Kuressāre': 'Burvīgā Sāremā sala ar viduslaiku bīskapa pili.',
    'Daugavpils': 'Latvijas otrā lielākā pilsēta ar unikālu 19. gs. cietoksni.',
    'Liepāja': 'Pilsēta, kur dzimst vējš. Brīnišķīgas pludmales un mūzikas tradīcijas.',
    'Haapsalu': 'Gleznainas jūrmalas kūrorta pilsēta ar bīskapa pili.',
    'Hiiumaa': 'Hiiumā sala slavena ar saviem bākiem un neskarto dabu.',
  },
  lt: {
    'Talinas': 'Viduramžių Senamiestis, UNESCO paveldas objektas. Istorijos ir modernumo derinys.',
    'Helsinkis': 'Suomijos sostinė su unikalia architektūra, dizainu ir jūros peizažais.',
    'Narva': 'Miestas dviejų kultūrų pasienyje su įspūdinga XIII a. tvirtove.',
    'Ryga': 'Baltijos perlas su didžiausia Art Nouveau pastatų kolekcija Europoje.',
    'Tartu': 'Studentų ir mokslo miestas su gyva jaunatviška atmosfera.',
    'Vilnius': 'Didžiausias Senamiestis Rytų Europoje, UNESCO paveldas.',
    'Varšuva': 'Kontrastų miestas: atstatytas Senamiestis ir modernūs dangoraižiai.',
    'Pernu': 'Estijos vasaros sostinė su nuostabiomis paplūdimiais.',
    'Kuressarė': 'Stebuklingoji Saremos sala su viduramžių vyskupo pilimi.',
    'Daugpilis': 'Antrasis pagal dydį Latvijos miestas su unikalia XIX a. tvirtove.',
    'Liepoja': 'Miestas, kuriame gimsta vėjas. Nuostabūs paplūdimiai ir muzikos tradicijos.',
    'Viljandis': 'Vaizdingas pajūrio kurortas su vyskupo pilimi.',
    'Hiiumaa': 'Hiiumos sala garsėja švyturiais ir nekliesta gamta.',
  },
  pl: {
    'Tallinn': 'Średniowieczne Stare Miasto, obiekt UNESCO. Połączenie historii i nowoczesności.',
    'Helsinki': 'Stolica Finlandii z unikalną architekturą, designem i morskimi krajobrazami.',
    'Narwa': 'Miasto na granicy dwóch kultur z imponującą twierdzą z XIII wieku.',
    'Ryga': 'Perła Bałtyku z największą kolekcją budynków secesyjnych w Europie.',
    'Tartu': 'Miasto studentów i nauki z żywą młodzieżową atmosferą.',
    'Wilno': 'Największe Stare Miasto w Europie Wschodniej, obiekt UNESCO.',
    'Warszawa': 'Miasto kontrastów: odbudowane Stare Miasto i nowoczesne wieżowce.',
    'Parnawa': 'Letnia stolica Estonii z pięknymi piaszczystymi plażami.',
    'Kuressaare': 'Magiczna wyspa Sarema ze średniowiecznym zamkiem biskupim.',
    'Dyneburg': 'Drugie co do wielkości miasto Łotwy z unikalną twierdzą z XIX w.',
    'Lipawa': 'Miasto, w którym rodzi się wiatr. Piękne plaże i tradycje muzyczne.',
    'Haapsalu': 'Malownicze nadmorskie miasto uzdrowiskowe z zamkiem biskupim.',
    'Hiiumaa': 'Wyspa Hiuma słynie z latarni morskich i dziewiczej przyrody.',
  },
};

const countryRoutes = {
  estonia: [
    ['tallinn', 'tartu'], ['tallinn', 'narva'], ['tallinn', 'parnu'], ['tallinn', 'viljandi'],
    ['tallinn', 'rakvere'], ['tallinn', 'kuressaare'], ['tallinn', 'haapsalu'], ['tallinn', 'hiiumaa'],
    ['tallinn', 'helsinki'], ['tallinn', 'spb'], ['tallinn', 'riga'], ['tallinn', 'vilnius'],
    ['tallinn', 'warsaw'], ['tartu', 'narva'], ['tartu', 'parnu'], ['tartu', 'viljandi'],
    ['parnu', 'riga'], ['narva', 'rakvere'],
  ],
  latvia: [
    ['riga', 'tallinn'], ['riga', 'vilnius'], ['riga', 'kaunas'], ['riga', 'warsaw'],
    ['riga', 'daugavpils'], ['riga', 'liepaja'], ['riga', 'parnu'], ['riga', 'panevezys'],
    ['riga', 'klaipeda'], ['riga', 'palanga'], ['riga', 'spb'],
  ],
  lithuania: [
    ['vilnius', 'riga'], ['vilnius', 'kaunas'], ['vilnius', 'warsaw'], ['vilnius', 'tallinn'],
    ['vilnius', 'panevezys'], ['vilnius', 'klaipeda'], ['vilnius', 'suwalki'],
    ['kaunas', 'warsaw'], ['kaunas', 'riga'], ['kaunas', 'klaipeda'], ['kaunas', 'suwalki'],
    ['panevezys', 'riga'], ['panevezys', 'warsaw'],
  ],
  russia: [['spb', 'tallinn'], ['spb', 'riga']],
  poland: [
    ['warsaw', 'vilnius'], ['warsaw', 'kaunas'], ['warsaw', 'riga'], ['warsaw', 'tallinn'],
    ['suwalki', 'vilnius'], ['suwalki', 'kaunas'], ['suwalki', 'warsaw'],
  ],
  finland: [['helsinki', 'tallinn'], ['helsinki', 'spb']],
};

const countryTabs = [
  { id: 'estonia', label: { ru: 'ЭСТОНИЯ', en: 'ESTONIA', lv: 'IGAUNIJA', lt: 'ESTIJA', pl: 'ESTONIA' } },
  { id: 'latvia', label: { ru: 'ЛАТВИЯ', en: 'LATVIA', lv: 'LATVIJA', lt: 'LATVIJA', pl: 'ŁOTWA' } },
  { id: 'lithuania', label: { ru: 'ЛИТВА', en: 'LITHUANIA', lv: 'LIETUVA', lt: 'LIETUVA', pl: 'LITWA' } },
  { id: 'russia', label: { ru: 'РОССИЯ', en: 'RUSSIA', lv: 'KRIEVIJA', lt: 'RUSIJA', pl: 'ROSJA' } },
  { id: 'poland', label: { ru: 'ПОЛЬША', en: 'POLAND', lv: 'POLIJA', lt: 'LENKIJA', pl: 'POLSKA' } },
  { id: 'finland', label: { ru: 'ФИНЛЯНДИЯ', en: 'FINLAND', lv: 'SOMIJA', lt: 'SUOMIJA', pl: 'FINLANDIA' } },
];

const countriesTitle = {
  ru: 'Lux Express работает в 6 странах',
  en: 'Lux Express operates in 6 countries',
  lv: 'Lux Express darbojas 6 valstīs',
  lt: 'Lux Express veikia 6 šalyse',
  pl: 'Lux Express działa w 6 krajach',
};

const countriesDesc = {
  ru: 'Самое актуальное расписание вы найдёте через поиск рейсов на нашем сайте.',
  en: 'You can find the most up-to-date schedule through the trip search on our website.',
  lv: 'Aktuālāko sarakstu atradīsiet mūsu mājaslapas reisu meklētājā.',
  lt: 'Naujausią tvarkaraštį rasite mūsų svetainės reisų paieškoje.',
  pl: 'Najaktualniejszy rozkład znajdziesz w wyszukiwarce na naszej stronie.',
};

const CountriesSection = ({ lang, navigate }) => {
  const [activeTab, setActiveTab] = React.useState('estonia');
  const routes = countryRoutes[activeTab] || [];

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[36px] font-semibold text-[#666] mb-3 leading-tight">
          {countriesTitle[lang] || countriesTitle.en}
        </h2>
        <p className="text-[16px] md:text-[18px] text-[#555] mb-8 max-w-[500px] leading-relaxed">{countriesDesc[lang] || countriesDesc.en}</p>

        {/* Country tabs */}
        <div className="flex gap-0 mb-8 border-b-2 border-gray-200 overflow-x-auto" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {countryTabs.map((tab) => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2.5 text-[13px] font-bold tracking-wide transition-colors relative ${
                activeTab === tab.id
                  ? 'text-[#333] border-b-[3px] border-[#c30909] -mb-[2px]'
                  : 'text-[#999] hover:text-[#555]'
              }`}>
              {tab.label[lang] || tab.label.en}
            </button>
          ))}
        </div>

        {/* Routes grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1 max-w-[700px]">
          {routes.map(([from, to], idx) => {
            const fromName = getCityName(from, lang);
            const toName = getCityName(to, lang);
            return (
              <button key={idx} onClick={() => navigate('/search')}
                className="flex items-center gap-2 md:gap-3 py-2 text-left hover:text-[#c30909] transition-colors group">
                <span className="text-[13px] md:text-[14px] text-[#333] group-hover:text-[#c30909] whitespace-nowrap">{fromName}</span>
                <svg width="16" height="10" viewBox="0 0 20 12" className="text-[#c30909] flex-shrink-0">
                  <line x1="0" y1="4" x2="18" y2="4" stroke="currentColor" strokeWidth="1.5"/>
                  <line x1="0" y1="8" x2="18" y2="8" stroke="currentColor" strokeWidth="1.5"/>
                  <polyline points="14,1 18,4 14,7" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                  <polyline points="4,5 0,8 4,11" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
                <span className="text-[13px] md:text-[14px] font-medium text-[#333] group-hover:text-[#c30909] whitespace-nowrap">{toName}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const DestinationsSection = ({ t, lang, destinationImages, setSearchParams, navigate }) => {
  const scrollRef = React.useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const getDesc = (city) => {
    const descs = destinationDescriptions[lang] || destinationDescriptions.en;
    return descs[city] || '';
  };
  const learnMore = { ru: 'УЗНАВАЙТЕ', en: 'LEARN MORE', lv: 'UZZINIET', lt: 'SUŽINOKITE', pl: 'DOWIEDZ SIĘ' };

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 10);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  React.useEffect(() => { checkScroll(); }, []);

  const scroll = (dir) => {
    if (scrollRef.current) {
      const cardWidth = 336; // 320px card + 16px gap
      const visibleCards = Math.floor(scrollRef.current.offsetWidth / cardWidth);
      const scrollAmount = cardWidth * Math.max(1, visibleCards - 1);
      scrollRef.current.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
      setTimeout(checkScroll, 600);
    }
  };

  return (
    <section id="destinations" className="py-8 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-3 md:px-4">
        <h2 className="text-[26px] md:text-[40px] font-semibold text-[#c30909] mb-6 md:mb-8">{t('destinations.title')}</h2>
        <div className="relative">
          <div ref={scrollRef} onScroll={checkScroll}
            className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', scrollBehavior: 'smooth' }}>
            {destinationImages.map((dest, idx) => (
              <div key={idx} className="flex-shrink-0 w-[300px] md:w-[380px] snap-start cursor-pointer group"
                onClick={() => {
                  if (dest.id) navigate(`/destination/${dest.id}`);
                }}>
                <div className="relative rounded-lg overflow-hidden aspect-[4/3] mb-4">
                  <img src={dest.url} alt={dest.city} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <h3 className="text-xl font-bold text-[#222] mb-2">{dest.city}</h3>
                <p className="text-[15px] text-[#444] leading-relaxed mb-3 line-clamp-3">{getDesc(dest.city)}</p>
                <p className="text-[15px] font-bold text-[#c30909] tracking-wide">{learnMore[lang] || learnMore.en}</p>
              </div>
            ))}
          </div>
        </div>
        {/* Navigation buttons */}
        <div className="flex items-center gap-4 mt-4">
          <button
            onClick={() => scroll(-1)}
            disabled={!canScrollLeft}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${!canScrollLeft ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <ChevronLeft size={16} strokeWidth={2.5} />
            <span className="font-medium">{t('reviews.prev')}</span>
          </button>
          <div className="flex-1 h-px bg-gray-200" />
          <button
            onClick={() => scroll(1)}
            disabled={!canScrollRight}
            className={`flex items-center gap-1.5 text-[14px] uppercase tracking-wider transition-colors ${!canScrollRight ? 'text-gray-300 cursor-not-allowed' : 'text-[#c30909] hover:text-[#a00707]'}`}
          >
            <span className="font-bold">{t('reviews.next')}</span>
            <ChevronRight size={16} strokeWidth={2.5} />
          </button>
        </div>
      </div>
      <style>{`.scrollbar-hide::-webkit-scrollbar { display: none; }`}</style>
    </section>
  );
};

const featureCards = [
  { titleKey: 'features.time.title', descKey: 'features.time.desc' },
  { titleKey: 'features.comfort.title', descKey: 'features.comfort.desc' },
  { titleKey: 'features.tv.title', descKey: 'features.tv.desc' },
  { titleKey: 'features.internet.title', descKey: 'features.internet.desc' },
];

const amenityIcons = [
  { icon: AirVent, key: 'amenity.ac' },
  { icon: Wifi, key: 'amenity.wifi' },
  { icon: Smartphone, key: 'amenity.eticket' },
  { icon: ShieldCheck, key: 'amenity.seatbelts' },
  { icon: null, key: 'amenity.wc', label: 'WC' },
];

const tipKeys = ['tips.2', 'tips.3', 'tips.4', 'tips.5'];

const HomePage = () => {
  const navigate = useNavigate();
  const { setSearchParams } = useBooking();
  const { t, lang } = useLanguage();
  const destinationImages = getDestinationImages(lang);

  return (
    <div>
      {/* Hero */}
      <section
        className="relative min-h-[420px] md:min-h-[560px] flex items-center justify-center bg-[#1a1a2e]"
      >
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'url(https://www.spaestonia.ee/resort/wp-content/uploads/2024/08/Luxexpress-1.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 max-w-[1280px] w-full mx-auto px-3 md:px-4 pt-20 md:pt-28 pb-6 md:pb-12" style={{ WebkitFontSmoothing: 'antialiased', textRendering: 'optimizeLegibility' }}>
          <div className="md:text-left text-center mb-6 md:mb-10 md:max-w-[600px]">
            <h1 className="text-[36px] md:text-[56px] font-semibold text-white drop-shadow-lg" style={{ lineHeight: 1.1, letterSpacing: '-0.5px' }}>{t('hero.title')}</h1>
            <p className="text-[20px] md:text-[36px] text-white/90 mt-3 md:mt-4 font-medium" style={{ lineHeight: 1.4 }}>{t('hero.subtitle')}</p>
          </div>
          <SearchForm />
        </div>
      </section>

      {/* Red divider line */}
      <div className="h-1 bg-[#c30909]" />

      {/* Features — Why passengers prefer Lux Express */}
      <section id="features" className="py-8 md:py-16 bg-white">
        <div className="max-w-[1280px] mx-auto px-3 md:px-4">
          <h2 className="text-[28px] md:text-[42px] font-semibold text-[#c30909] mb-6 md:mb-10">{t('features.title')}</h2>
          {/* 4 feature cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-12">
            {featureCards.map((f, idx) => (
              <div key={idx}>
                <h3 className="text-[20px] md:text-[24px] font-medium text-[#222] mb-3">{t(f.titleKey)}</h3>
                <p className="text-[15px] md:text-[16px] text-[#555] leading-relaxed">{t(f.descKey)}</p>
              </div>
            ))}
          </div>
          {/* Amenity icons divider */}
          <div className="border-t pt-5 md:pt-10">
            <div className="grid grid-cols-5 gap-2 md:gap-6">
              {amenityIcons.map((a, idx) => (
                <div key={idx} className="flex flex-col items-center text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#f0f0f1] flex items-center justify-center mb-3">
                    {a.icon ? <a.icon size={24} className="text-[#333] md:w-[28px] md:h-[28px]" strokeWidth={1.5} /> : <span className="text-sm md:text-base font-bold text-[#333]">{a.label}</span>}
                  </div>
                  <p className="text-[14px] md:text-[16px] font-medium text-[#333]">{t(a.key)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Destinations gallery — horizontal scroll with descriptions */}
      <DestinationsSection t={t} lang={lang} destinationImages={destinationImages} setSearchParams={setSearchParams} navigate={navigate} />

      {/* Countries & Routes */}
      <CountriesSection lang={lang} navigate={navigate} />

      {/* Passenger Reviews */}
      <ReviewsSection t={t} />

      {/* Tips */}
      <section id="tips" className="py-8 md:py-16 bg-white">
        <div className="max-w-[1280px] mx-auto px-3 md:px-4">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-12">
            <div className="w-full md:w-1/3 rounded-xl overflow-hidden">
              <img src="https://images.unsplash.com/photo-1494515843206-f3117d3f51b7?w=400&h=500&fit=crop" alt="Travel" className="w-full h-[180px] md:h-[300px] object-cover" />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-[#c30909] mb-4">{t('tips.title')}</h2>
              <ul className="space-y-3 text-sm text-[#484c55]">
                {tipKeys.map((key) => (
                  <li key={key} className="flex items-start gap-2">
                    <span className="text-[#c30909] font-bold mt-0.5">•</span>
                    {t(key)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
